import { jsx as _jsx } from "react/jsx-runtime";
import { HoldingImage } from "@cinch-nx/shared-ui";
import Image from "next/image";
import styles from "./vehicle-image.module.css";
export var VehicleImage = function(param) {
    var isAvailable = param.isAvailable, src = param.src, alt = param.alt;
    var hasImage = src && src.length > 0;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.imageContainer,
        children: hasImage && isAvailable ? /*#__PURE__*/ _jsx(Image, {
            className: styles.image,
            src: src,
            alt: alt,
            layout: "fill"
        }) : /*#__PURE__*/ _jsx(HoldingImage, {
            text: "Image Unavailable",
            isAvailable: isAvailable
        })
    });
};
